module.exports = __webpack_public_path__ + "static/img/mine2.7796723f.png";